import { observer } from "mobx-react-lite";
import * as React from "react";
import { PageLayout } from "src/components/PageLayout";
import { DemoTable } from "src/components/tables/DemoTable";

export const DemoTablePage: React.FC = observer(() => (
  <PageLayout pageTitle="DemoTable">
    <DemoTable />
  </PageLayout>
));
